import "../../assets/css/child-info.css";
import { useContext } from "react";
import PropTypes from "prop-types";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { solid } from "@fortawesome/fontawesome-svg-core/import.macro";
import StateContext from "../../state/stateContext";
import useQueryChildData from "../Hooks/useQueryChildData";
import PanelTile from "../Panel/PanelTileShimmer";
import ChildAttribute from "./ChildAttribute";
import ChildPhoto from "./ChildPhoto";
import { mapChildData } from "../../helpers/helpers";

export function ChildInfo(props) {
  const context = useContext(StateContext);
  const childInfo = useQueryChildData(context);
  const childData = childInfo.data;
  const {
    ageGenderInfo,
    birthDayInfo,
    languageInfo,
    locationInfo,
    hobbyInfo,
    subjectInfo,
    name,
  } = ((status) => {
    if (status !== "success") {
      return {};
    }

    const {
      name,
      gender,
      age,
      birthDay,
      birthMonthName,
      language,
      projectName,
      countryName,
      subject,
      hobby,
    } = mapChildData(childData);

    // Child Attributes
    return {
      ageGenderInfo:
        age < 1 ? (
          `Baby ${gender}`
        ) : (
          <>
            <span className="child-info-gender">{gender}</span>, age{" "}
            <span className="child-info-age">{age}</span>
          </>
        ),
      birthDayInfo: `${birthMonthName} ${birthDay}`,
      languageInfo: `Speaks ${language}`,
      locationInfo: `${projectName}, ${countryName}`,
      hobbyInfo: hobby ? `My favorite hobby is ${hobby.toLowerCase()}` : null,
      subjectInfo: subject ? `My favorite subject is ${subject}` : null,
      name,
    };
  })(childInfo.status);

  return (
    <PanelTile
      classList="child-info"
      renderImage={() => <ChildPhoto />}
      showShimmer={!childInfo.isSuccess}
      shimmerProps={{ height: "730px" }}
    >
      <div className="ChildInfoDetails">
        <h3 className="child-info__name">{name}</h3>
        <div className="child-info__attributes">
          <ChildAttribute
            attrType={<FontAwesomeIcon icon={solid("child-reaching")} />}
            attrValue={ageGenderInfo}
          />

          <ChildAttribute
            attrType={<FontAwesomeIcon icon={solid("cake-candles")} />}
            attrValue={birthDayInfo}
          />

          <ChildAttribute
            attrType={<FontAwesomeIcon icon={solid("comments")} />}
            attrValue={languageInfo}
          />

          <ChildAttribute
            attrType={<FontAwesomeIcon icon={solid("location-arrow")} />}
            attrValue={locationInfo}
          />

          <ChildAttribute
            attrType={<FontAwesomeIcon icon={solid("futbol")} />}
            attrValue={hobbyInfo}
            hideIfEmpty={true}
          />

          <ChildAttribute
            attrType={<FontAwesomeIcon icon={solid("book")} />}
            attrValue={subjectInfo}
            hideIfEmpty={true}
          />
        </div>
      </div>
    </PanelTile>
  );
}
  
export default ChildInfo;